import React, { ReactNode, useCallback } from 'react';
import { Layout } from 'antd';
import { observer } from 'mobx-react-lite';
import { ScrollRestoration } from 'react-router-dom';

import { SideMenu } from '../../side-menu';
import { Header } from './header';

import styles from './base.module.css';

const { Sider } = Layout;

type TBaseLayoutProps = {
  header: string;
  children: ReactNode;
};

const MainMenu = observer(() => {
  const [menuCollapsed, setColapsed] = React.useState(false);
  const changeCollapsed = useCallback(() => setColapsed((state) => !state), []);

  return (
    <Sider
      width="250"
      theme="light"
      collapsible={true}
      collapsed={menuCollapsed}
      draggable={false}
      onCollapse={changeCollapsed}
    >
      <SideMenu />
    </Sider>
  );
});

export const BaseLayout = observer(({ header, children }: TBaseLayoutProps) => {
  return (
    <div className={styles.root}>
      <Header title={header} />
      <div className={styles.body}>
        <MainMenu />

        <main className={styles.content}>
          {children}
          <ScrollRestoration />
        </main>
      </div>
    </div>
  );
});
